const frTranslation = {
  Breadcrumb_Cycles: 'Cycles',
  Breadcrumb_Contents: 'Contenus',
  Breadcrumb_Home: 'Accueil',
  Breadcrumb_Role: 'Rôle',
  Breadcrumb_Actions: 'Actions',
  Breadcrumb_List: 'Liste',
  Breadcrumb_Program: 'Programmes',
  Breadcrumb_Contacts: 'Contacts',
  Breadcrumb_Locations: 'Lieux',
  Breadcrumb_Roles: 'Rôles',
  Breadcrumb_Users: 'Utilisateurs',
  Breadcrumb_EditCycle: 'Modifier le Cycle',
  Breadcrumb_Calender: 'Calendrier',

  Btn_Save: 'Enregistrer',
  Btn_Start: 'Démarrer',
  Btn_ReOpen: 'Rouvrir',
  Btn_Comment: 'Commenter',
  Btn_Create: 'Créer',
  Btn_Continue: 'Continuer',
  Btn_AddLocation: 'Ajouter un Lieu',
  Btn_Export: 'Exporter',
  Btn_SaveFilter: 'Enregistrer le Filtre',
  Btn_SavedFilter: 'Filtre Enregistré',
  Btn_AuditHistory: 'Historique d’Audit',
  Btn_ShowFilter: 'Afficher le Filtre',
  Btn_HideFilter: 'Masquer le Filtre',
  Btn_Delete: 'Supprimer',
  Btn_Apply: 'Appliquer',
  Btn_ClearFilters: 'Effacer les Filtres',
  Btn_ManageDisplay: 'Gérer l’Affichage',
  Btn_Logout: 'Déconnexion',
  Btn_Add: 'Ajouter',
  Btn_Cancel: 'Annuler',
  Btn_Yes: 'Oui',
  Btn_No: 'Non',
  Btn_Upload: 'Téléverser',
  Btn_Submit: 'Soumettre',
  Btn_Update: 'Mettre à jour',
  Btn_AddNew: 'Ajouter Nouveau',
  Btn_StateGraph: 'Graphique d’État',
  Btn_Close: 'Fermer',
  Btn_EditNa: 'Modifier la Liste NA',
  Btn_NewAction: 'Nouvelle Action',
  Btn_NewEvent: 'Nouvel Événement',
  Btn_Action: 'Action',
  Btn_GenerateReport: 'Générer le Rapport',
  Btn_ShowMoreComments: 'Plus',
  Btn_Load5MoreLastCompletedActions: 'Charger 5 actions terminées supplémentaires',
  Btn_EditEnrollment: 'Modifier la Liste d’Inscription',
  Btn_Audit: 'Audit',
  Btn_Audit2: 'Audit2',
  Btn_UploadThenProcess: 'Téléverser puis Traiter',
  Btn_ProcessExisting: 'Traiter l’Existant',
  Btn_AddMethods: 'Ajouter Méthode(s)',
  Btn_CopyMethods: 'Copier Méthode(s)',
  Btn_ManageFilters: 'Gérer les Filtres',
  Btn_Recheck: 'Revérifier',
  Btn_Caveats: 'Avertissements',
  Btn_Copy: 'Copier',
  Btn_Profile: 'Profil',
  Btn_Validate: 'Valider',
  Btn_Enrollment: 'Inscription',
  Btn_ChangeMyPassword: 'Changer mon mot de passe',
  Btn_NAList: 'Liste NA',
  Btn_Contact: 'Contact',
  Btn_PrintPDF: 'Imprimer PDF',
  Btn_DownloadExcel: 'Télécharger Excel',
  Btn_FinalizeAndEmail: 'Finaliser et Envoyer par Email',
  Btn_Finalize: 'Finaliser',
  Btn_Refinalize: 'Re‑finaliser',
  Btn_Broadcast: 'Diffuser',
  Btn_SaveAsTemplate: 'Enregistrer comme Modèle',
  Btn_Reset: 'Réinitialiser',
  Btn_AddActions: 'Ajouter Action',
  Btn_Replicate: 'Dupliquer',
  Btn_Retry: 'Réessayer',
  Btn_Edit: 'Modifier',
  Btn_Complete: 'Terminer',
  Btn_Search: 'Rechercher',

  Column_Action: 'Action',
  Column_Filename: 'Nom du Fichier',
  Column_CreatedBy: 'Créé Par',
  Column_CreatedOn: 'Créé Le',
  Column_LastUpdatedOn: 'Mis à jour Le',
  Column_LastUpdatedBy: 'Mis à jour Par',
  Column_LastUpdatedByName: 'Mis à jour Par',
  Column_AccreditationBody: 'Organisme d’Accréditation',
  Column_ExpirationDate: 'Date d’Expiration',
  Column_AuditDate: 'Date d’Audit',
  Column_NoofMajorNC: 'Nb de NC Majeures',
  Column_NoofMinorNC: 'Nb de NC Mineures',
  Column_NoOfRecommendations: 'Nb de Recommandations',
  Column_FileName: 'Nom du Fichier',
  Column_UploadedOn: 'Téléversé Le',
  Column_UploadedBy: 'Téléversé Par',
  Column_Name: 'Nom',
  Column_Comments: 'Commentaires',
  Column_ContentID: 'ID de Contenu',
  Column_ListID: 'ID de Liste',
  Column_ListName: 'Nom de la Liste',
  Column_Active: 'Actif',
  Column_RoleName: 'Nom du Rôle',
  Column_Description: 'Description',
  Column_Role: 'Rôle',
  Column_CountryName: 'Nom du Pays',
  Column_RegionName: 'Nom de la Région',
  Column_UserID: 'ID Utilisateur',
  Column_FirstName: 'Prénom',
  Column_LastName: 'Nom',
  Column_DocumentName: 'Nom du document',
  Column_ContentType: 'Type de contenu',
  Column_ContentCategory: 'Catégorie de contenu',
  Column_Title: 'Titre',
  Column_ActionType: 'Type d’action',
  Column_AssignedTo: 'Assigné à',
  Column_Status: 'Statut',
  Column_DueDate: 'Date d’échéance',
  Column_CompletedOn: 'Terminé le',
  Column_ListEntryID: 'ID de l’entrée de liste',
  Column_StoreValue: 'Valeur stockée',
  Column_DisplayValue: 'Valeur affichée',

  Error_MaxLengthIs100: 'Longueur maximale : 100',
  Error_MaxLengthIs10: 'Longueur maximale : 10',
  Error_Message_SomethingWentWrong: 'Une erreur est survenue !',
  Error_LocationNameIsRequired: 'Le nom du lieu est requis',
  Error_LocationTypeIsRequired: 'Le type de lieu est requis',
  Error_CountryIsRequired: 'Le pays est requis',
  Error_RegionIsRequired: 'La région est requise',
  Error_RoleNameIsRequired: 'Le nom du rôle est requis',
  Error_DescriptionIsRequired: 'La description est requise',
  Error_SourceSystemIsRequired: 'Système source requis',
  Error_LevelIsRequired: 'Le niveau est requis',
  Error_RegionCodeIsRequired: 'Le code région est requis',
  Error_MaxLengthIs5: 'Longueur maximale : 5',
  Error_ProgramNameRequired: 'Le nom du programme est requis',
  Error_ProgramProductsRequired: 'Les produits du programme sont requis',
  Error_OrganizationRequired: 'L’organisation est requise',
  Error_BusinessLineRequired: 'La ligne de métier est requise',
  Error_LoadingDataError: 'Erreur de chargement des données',
  Error_NoItemsFound: 'Aucun élément trouvé !',
  Error_DueDateRequired: 'La date d’échéance est requise',
  Error_DateTimeFormatRequired: 'Le format date/heure est requis',
  Error_DateFormatRequired: 'Le format de date est requis',
  Error_ProcessDateRequired: 'La date de traitement est requise',
  Error_CycleNameIsRequired: 'Le nom du cycle est requis',
  Error_ProgramIsRequired: 'Le programme est requis',
  Error_MethodNameIsRequired: 'Le nom de la méthode est requis',
  Error_LocationAbbreviationIsRequired: 'L’abréviation du lieu est requise',
  Error_MaxLengthIs3: 'Longueur maximale : 3',
  Error_MaxLength: 'Longueur maximale : {{length}}',
  Error_OnlyUpperCaseLettersAllowed: 'Seules les lettres majuscules sont autorisées',
  Error_NameIsRequired: 'Le nom est requis',
  Error_NoPresetFound: 'Aucun préréglage trouvé !',
  Error_Message_ChangePasswordError: 'Échec du changement de mot de passe',
  Error_FirstNameIsRequired: 'Le prénom est requis',
  Error_LastNameIsRequired: 'Le nom de famille est requis',
  Error_EmailIsRequired: 'L’e‑mail est requis',
  Error_DateFormatIsRequired: 'Le format de date est requis',
  Error_DateTimeFormatIsRequired: 'Le format date/heure est requis',
  Error_MaxLengthIs50: 'Longueur maximale : 50',
  Error_AccreditationBodyRequired: 'L’organisme d’accréditation est requis',
  Error_ExpirationDateRequired: 'La date d’expiration est requise',
  Error_UploadDocumentFirst: 'Téléversez d’abord le document',
  Error_ReasonIsRequired: 'La raison est requise',
  Error_ActionTypeRequired: 'Le type d’action est requis',
  Error_TitleRequired: 'Le titre est requis',
  Error_StatusNameRequired: 'Le nom du statut est requis',
  Error_AssignedToRequired: 'Assigné à est requis',
  Error_TitleIsRequired: 'Le titre est requis',
  Error_ContentGroupIsRequired: 'Le groupe de contenu est requis',
  Error_ContentTypeIsRequired: 'Le type de contenu est requis',
  Error_TagIsRequired: 'Le tag est requis',
  Error_TestItemAlreadyExists: 'Le(s) paramètre(s) [{{items}}] existe(nt) déjà dans le programme',
  Error_UnableToLogout: 'Impossible de se déconnecter.',
  Error_ColumnUpdateFailed: 'Échec de mise à jour de l’affichage des colonnes !',
  Error_UnableToResetPassword: 'Impossible de réinitialiser le mot de passe.',
  Error_DashboardConfigurationCouldNotBeSaved: 'La configuration du tableau de bord n’a pas pu être enregistrée.',
  Error_DashboardConfigurationCouldNotBeReset: 'La configuration du tableau de bord n’a pas pu être réinitialisée.',
  Error_DashboardDefaultCannotBeRetrieved: 'Le tableau de bord par défaut n’a pas pu être récupéré.',
  Header_General: 'Général',
  Header_Actions: 'Actions',
  Header_MyActions: 'Mes Actions',
  Header_Action_Column_New: 'À faire',
  Header_Action_Column_Started: 'En cours',
  Header_Action_Column_Completed: 'Terminé',
  Header_ProgramInfo: 'Infos Programme',
  Header_AddLocation: 'Ajouter un Lieu',
  Header_EditLocation: 'Modifier le Lieu',
  Header_AddRole: 'Ajouter un Rôle',
  Header_EditRole: 'Modifier le Rôle',
  Header_List: 'Liste',
  Header_ProgramSearch: 'Programmes',
  Header_AddProgram: 'Ajouter un Programme',
  Header_EditProgram: 'Modifier le Programme',
  Header_Action: 'Actions',
  Header_Region: 'Région',
  Header_AuditForCycle: 'Audit pour - {{cycleName}}',
  Header_AddEditAccreditation: '{{op}} Accréditations - {{location}}',
  Header_Role: 'Rôles',
  Header_User: 'Utilisateurs',
  Header_UserCreate: 'Créer un Utilisateur',
  Header_RoleAndAccess: 'Rôles et Accès',
  Header_AddContent: 'Ajouter un Contenu',
  Header_EditContent: 'Modifier le Contenu',
  Header_ContentsSearch: 'Contenus',
  Header_Locations: 'Lieux',
  Header_Profile: 'Profil',
  Header_EditUser: 'Modifier l’Utilisateur',
  Header_Accreditations: 'Accréditations',
  Header_WelcomeToDashboard: 'Bienvenue sur la page d’accueil du Knowledge Center.',
  Header_Calender: 'Calendrier',
  Header_Dashboard: 'Tableau de Bord',

  Label_SortBy: 'Trier par',
  Label_Direction: 'Direction',
  Label_Ascending: 'Croissant',
  Label_Descending: 'Décroissant',
  Label_Edit: 'Modifier',
  Label_Accreditation: 'Accréditation',
  Label_Organization: 'Organisation',
  Label_ProgramName: 'Programme',
  Label_CreatedBy: 'Créé Par',
  Label_CreatedOn: 'Créé Le',
  Label_ProgramProducts: 'Produits',
  Label_ProgramComments: 'Commentaires du Programme',
  Label_Name: 'Nom',
  Label_RoleName: 'Nom du Rôle',
  Label_CategoryGroup: 'Groupe de Catégorie',
  Label_Category: 'Catégorie',
  Label_SourceSystem: 'Système Source',
  Label_ContentName: 'Nom du Contenu',
  Label_RoleInfo: 'Infos Rôle',
  Label_UserInfo: 'Infos Utilisateur',
  Label_Access: 'Accès',
  Label_Active: 'Actif',
  Label_Title: 'Titre',
  Label_Zone: 'Zone',
  Label_ActionStatus: 'Statut d’Action',
  Label_ActionType: 'Type d’Action',
  Label_StatusName: 'Nom du Statut',
  Label_AssignedTo: 'Assigné À',
  Label_CreatedOnFrom: 'Créé à partir de',
  Label_CreatedOnTo: 'Créé jusqu’à',
  Label_DueDateFrom: 'Échéance à partir de',
  Label_DueDateTo: 'Échéance jusqu’à',
  Label_Roles: 'Rôles',
  Label_Description: 'Description',
  Label_User: 'Utilisateur',
  Label_LocationName: 'Nom du Lieu',
  Label_LocationType: 'Type de Lieu',
  Label_ContentGroup: 'Groupe de Contenu',
  Label_UserType: 'Type d’Utilisateur',
  Label_LocationAlias: 'Alias du Lieu',
  Label_Alias: 'Alias',
  Label_Region: 'Région',
  Label_Regions: 'Régions',
  Label_Tenant: 'Locataire',
  Label_State: 'État',
  Label_City: 'Ville',
  Label_PostCode: 'Code Postal',
  Label_AddressLine2: 'Adresse Ligne 2',
  Label_AddressLine1: 'Adresse Ligne 1',
  Label_LocationAbbreviation: 'Abréviation du Lieu',
  Label_Abbreviation: 'Abréviation',
  Label_Timezone: 'Fuseau Horaire',
  Label_FirstName: 'Prénom',
  Label_LastName: 'Nom',
  Label_ListName: 'Nom de la Liste',
  Label_Filters: 'Filtres',
  Label_Method: 'Méthode',
  Label_TestItem: 'Paramètre',
  Label_AutoImport: 'Import Auto',
  Label_FreqYr: 'Fréq/An',
  Label_SearchMethod: 'Rechercher une Méthode',
  Label_No_Records_Found: 'Aucun enregistrement trouvé !',
  Label_Attachments: 'Pièces Jointes',
  Label_Parameter: 'Paramètre',
  Label_TestMethod: 'Méthode',
  Label_Unit: 'Unité',
  Label_Products: 'Produits',
  Label_TestItems: 'Paramètres',
  Label_LocationInfo: 'Infos du Lieu',
  Label_ContentInfo: 'Infos du Contenu',
  Label_ContentHistory: 'Historique du Contenu',
  Label_VersionHistory: 'Historique des Versions',
  Label_General: 'Général',
  Label_Address: 'Adresse',
  Label_BusinessLines: 'Lignes de Métier',
  Label_Product: 'Produit',
  Label_Email: 'E‑mail',
  Label_DateFormat: 'Format de Date',
  Label_DateTimeFormat: 'Format Date/Heure',
  Label_Level: 'Niveau',
  Label_Default: 'Défaut',
  Label_Type: 'Type',
  Label_Role: 'Rôle',
  Label_NewPassword: 'Nouveau Mot de Passe',
  Label_ConfirmNewPassword: 'Confirmer le Nouveau Mot de Passe',
  Label_Phone: 'Téléphone',
  Label_Countries: 'Pays',
  Label_Locations: 'Lieux',
  Label_AddTag: 'Ajouter un Tag',
  Label_NND: 'NND',
  Label_Resolution: 'Résolution',
  Label_TestItemsForMethod: 'Paramètres pour {{ methodName }}',
  Label_Scope: 'Portée',
  Label_ListEntry: 'Entrée de Liste',
  Label_NA: 'NA',
  Label_Location: 'Lieu',
  Label_Country: 'Pays',
  Label_BusinessLine: 'Ligne de Métier',
  Label_Program: 'Programme',
  Label_Comments: 'Commentaires',
  Label_Comment: 'Commentaire',
  Label_Tags: 'Tags',
  Label_AppliedMethodsAndTest: 'Méthodes et Paramètres Appliqués',

  Label_Attachment: 'Pièce Jointe',
  Label_Selected: 'Sélectionné',
  Label_Methods: 'Méthodes',
  Label_EditList: 'Modifier la Liste',
  Label_ListEntries: 'Entrées de Liste',
  Label_ViewMore: 'Voir Plus',
  Label_ViewLess: 'Voir Moins',
  Label_UpdateNAList: 'Mettre à jour la Liste NA',
  Label_AccreditationLogoText: 'Texte du Logo d’Accréditation',
  Label_CertificateHyperlink: 'Lien du Certificat',
  Label_ScopeHyperlink: 'Lien de la Portée',
  Label_Latitude: 'Latitude',
  Label_Longitude: 'Longitude',
  Label_MainContact: 'Contact Principal',
  Label_SavingProgramMethods: 'Enregistrement des Méthodes du Programme',
  Label_Reason: 'Raison',
  Label_HiUser: 'Bonjour {{username}} !',
  Label_AssignedXActions: 'Il y a &lt;0&gt;{{n}}&lt;/0&gt; nouvelles actions vous étant assignées.',
  Label_XAnnouncemnets: 'Il y a &lt;0&gt;{{n}}&lt;/0&gt; nouvelles annonces diffusées pour vous.',
  Label_Search: 'Rechercher',
  Label_RetriedBy: 'Réessayé le {{retryOn}} par {{retryBy}}',
  Label_Stretch: 'Étiré',
  Label_Compact: 'Compact',
  Label_MethodBase: 'Base de Méthode',
  Label_ParameterBase: 'Base de Paramètre',
  Label_CalculationStrategy: 'Stratégie de Calcul',
  Label_ContentType: 'Type de Contenu',
  Label_VisibleFor: 'Visible Pour',
  Label_ActionTitle: 'Titre de l’Action',
  Label_DueDate: 'Date d’Échéance',
  Label_ContentID: 'ID de Contenu',
  Label_Action: 'Action',
  Label_Monthly: 'Mensuel',
  Label_Weekly: 'Hebdomadaire',
  Label_ListID: 'ID de Liste',
  Label_LastUpdatedOn: 'Mis à jour Le',
  Label_LastUpdatedBy: 'Mis à jour Par',
  Label_RoleNames: 'Noms des Rôles',
  Label_CountryName: 'Nom du Pays',
  Label_RegionName: 'Nom de la Région',
  Label_UserID: 'ID Utilisateur',
  Label_Functionality: 'Fonctionnalité',
  Label_Custom_Functionality: 'Fonctionnalité personnalisée',

  Message_NoComments: 'Aucun commentaire',
  Message_NoItems: 'Aucun élément !',

  Confirm_Message_UnsavedProgram:
    'Voulez-vous fermer la fenêtre sans enregistrer le programme ?',

  Nav_Menu_Program: 'Programme',
  Nav_Menu_Contents: 'Contenus',
  Nav_Menu_Capability: 'Capabilité',
  Nav_Menu_MyActions: 'Mes Actions',
  Nav_Menu_Actions: 'Actions',
  Nav_Menu_Calender: 'Calendrier',
  Nav_Menu_Dashboard: 'Tableau de Bord',
  Nav_Menu_Home: 'Accueil',
  Nav_Menu_MasterData: 'Données Maîtres',
  Nav_Menu_List: 'Liste',
  Nav_Menu_Administrator: 'Administrateur',
  Nav_Menu_Roles: 'Rôles',
  Nav_Menu_Users: 'Utilisateurs',

  Placeholder_Selectanoption: 'Sélectionner une option',
  PlaceHolder_Comments: 'Commentaires',
  Placeholder_SelectSourceSystem: 'Sélectionner le Système Source',

  Tab_Title_AppName: 'CTD KC',
  Tab_Profile: 'Profil',
  Tab_Announcement: 'Annonce',
  Tab_Notification: 'Notification',

  Table_NoUserfound: 'Aucun utilisateur trouvé !',

  Text_AddContent: 'Ajouter un Contenu',
  Text_EditContent: 'Modifier le Contenu',
  Text_AddLocation: 'Ajouter un Lieu',
  Text_EditLocation: 'Modifier le Lieu',
  Text_EditRole: 'Modifier le Rôle',
  Text_AddRole: 'Ajouter un Rôle',
  Text_True: 'Vrai',
  Text_False: 'Faux',

  Title_Showing_X_Records: 'Affichage de {{length}} enregistrement(s)',
  Title_NewList: 'Nouvelle Liste',
  Title_DataExport: 'Export de Données',

  Toast_CreatedSuccessfully: 'Créé avec succès',
  Toast_UpdatedSuccessfully: 'Mis à jour avec succès',
  Toast_ColumnUpdatedSuccessfully: 'Affichage des colonnes mis à jour avec succès',
  Toast_ActionStatusUpdatedSuccessfully: 'Statut de l’Action mis à jour avec succès',
  Toast_UpdateFailed: 'Échec de la mise à jour',
  Toast_ColumnUpdateFailed: 'Échec de mise à jour de l’affichage des colonnes',
  Toast_FilterDisplayUpdatedSuccessfully: 'Affichage du filtre mis à jour avec succès !',
  Toast_FilterDisplayUpdateFailed: 'Échec de mise à jour de l’affichage du filtre !',
  Toast_UnableToSaveFilter: 'Impossible d’enregistrer le préréglage du filtre !',
  Toast_SavedSuccessfully: 'Enregistré avec succès !',
  Toast_FilesUploadedSuccessfully: 'Fichier(s) téléversé(s) avec succès',
  Toast_FileDownloadedSuccessfully: 'Fichier téléchargé avec succès !',
  Toast_FileDeletedSuccessfully: 'Fichier(s) supprimé(s) avec succès',
  Toast_MethodAndParameterAlreadyExists:
    'La méthode et le paramètre sélectionnés existent déjà dans le programme',
  Toast_AcknowledgedSuccessfully: 'Confirmé avec succès',
  Toast_ProfileUpdatedSuccessfully: 'Profil mis à jour avec succès !',
  Toast_NoteAddedSuccessfully: 'Note ajoutée avec succès !',
  Toast_ProgramUpdatedSuccessfully: 'Programme mis à jour avec succès !',
  Toast_ProgramCreatedSuccessfully: 'Programme créé avec succès !',
  Toast_DashboardConfigurationSavedSuccessfully:
    'Configuration du tableau de bord enregistrée avec succès !',
  Toast_DashboardConfigurationResettedSuccessfully:
    'Configuration du tableau de bord réinitialisée avec succès !',

  Tooltip_ContentsSearch: 'KC | Recherche de Contenus',
  Tooltip_List: 'KC | Liste',
  Tooltip_Role: 'KC | Rôles',
  Tooltip_User: 'KC | Utilisateurs',
  Tooltip_Download: 'Télécharger',
  Tooltip_Default: 'Défaut',
  Tooltip_ActionSearch: 'KC | Recherche d’Actions',
  Tooltip_AddLocation: 'KC | Ajouter un Lieu',
  Tooltip_EditLocation: 'KC | Modifier un Lieu',
  Tooltip_Export_To_CSV: 'Exporter en CSV',
  Tooltip_Locations: 'KC | Lieux',
  Tooltip_AddContent: 'KC | Ajouter un Contenu',
  Tooltip_EditContent: 'KC | Modifier un Contenu',
  Tooltip_Favorite: 'Favori',
  Tooltip_Unfavorite: 'Retirer des Favoris',
  Tooltip_EditLayout: 'Modifier la Mise en Page',
  Tooltip_Calendar: 'Calendrier',
  Tooltip_ReadAndUnderstand: 'Lire et Comprendre',
  Tooltip_MethodEquivalence: 'Équivalence des Méthodes',
  Tooltip_CompanySummaryReport: 'KC | Rapport Résumé Entreprise',
  Tooltip_DataExport: 'KC | Export de Données',
  Tooltip_ReportGrading: 'KC | Notation du Rapport',
  Tooltip_LabSummaryReport: 'KC | Rapport de Localisation',
  Tooltip_AndersonDarling: 'Anderson Darling',
  Tooltip_EditUser: 'KC | Modifier Utilisateur',
};

export default frTranslation;
